<template>
  <div class="number-input-container mb-3">
    <!-- Input A -->
    <div class="mb-4">
      <label>a.Did you make the decision to travel?</label>
      <div class="form-inline">
        <input
          type="number"
          v-model.number="inputA.value"
          class="form-control i1"
          placeholder="value"
          min="0"
          @input="updateAnswer()"
        />
        <select
          v-model="inputA.type"
          class="form-control form-select i2"
          @change="updateAnswer()"
        >
          <option value="days">Days</option>
          <option value="month">Months</option>
        </select>
      </div>
      <small v-if="showValidation && errorA" class="text-danger">{{ errorA }}</small>
    </div>

    <!-- Input B -->
    <div class="mb-4">
      <label>b.Did you make your air travel reservations?</label>
      <div class="form-inline">
        <input
          type="number"
          v-model.number="inputB.value"
          class="form-control i1"
          placeholder="value"
          min="0"
          @input="updateAnswer()"
        />
        <select
          v-model="inputB.type"
          class="form-control form-select i2"
          @change="updateAnswer()"
        >
          <option value="days">Days</option>
          <option value="month">Months</option>
        </select>
      </div>
      <small v-if="showValidation && errorB" class="text-danger">{{ errorB }}</small>
    </div>
  </div>
</template>

<script>
import surveyService from '@/services/surveyService';

export default {
  props: {
    question: Object,
    showValidation: Boolean
  },
  data() {
    const storedAnswer = surveyService.getAnswer(this.question.id) || {};
    const answerA = storedAnswer.a || { type: 'days', value: '' };
    const answerB = storedAnswer.b || { type: 'days', value: '' };

    return {
      inputA: { ...answerA },
      inputB: { ...answerB },
      errorA: '',
      errorB: ''
    };
  },
  methods: {
    updateAnswer() {
      // const input = key === 'a' ? this.inputA : this.inputB;

      // Save to survey service (you can keep this as-is if you want)
      surveyService.setAnswer(this.question.id, {
        a: { ...this.inputA },
        b: { ...this.inputB }
      });


      // Emit structured object with question.id as key
      this.$emit('input', {
        [this.question.id]: {
          a: { ...this.inputA },
          b: { ...this.inputB }
        }
      });

      this.validateAll();
    },
    validateAll() {
      this.errorA = '';
      this.errorB = '';

      const checkLimit = (val, type) => {
        if (type === 'days' && val > 730) return true;
        if (type === 'month' && val > 24) return true;
        return false;
      };

      // Early termination condition
      const terminate =
        checkLimit(this.inputA.value, this.inputA.type) ||
        checkLimit(this.inputB.value, this.inputB.type);

      if (terminate) {
        this.terminateSurvey(); // Emit to parent
        return; // Skip rest of validation
      }

      // Input A
      if (this.question.required && (this.inputA.value === '' || this.inputA.value == null)) {
        this.errorA = 'This field is required.';
      } else if (this.inputA.value < 0) {
        this.errorA = 'Must be positive.';
      }

      // Input B
      if (this.question.required && (this.inputB.value === '' || this.inputB.value == null)) {
        this.errorB = 'This field is required.';
      } else if (this.inputB.value < 0) {
        this.errorB = 'Must be positive.';
      }

      // Cross-validation
      const aInDays = this.toDays(this.inputA);
      const bInDays = this.toDays(this.inputB);
      if (aInDays != null && bInDays != null && bInDays > aInDays) {
        this.errorB = 'Must be less than or equal to the first value.';
      }

      const hasError = !!(this.errorA || this.errorB);
      this.$emit('validation-status', hasError);
    },

    toDays({ value, type }) {
      if (value === '' || value == null) return null;
      return type === 'month' ? value * 30 : value;
    },
    terminateSurvey() {
      // 🚨 Add your termination logic here
      // For example: this.$emit('terminate') or router push
      //console.warn('Survey terminated due to exceeding limits.');
    }
  }

};
</script>
